import { Flex, forwardRef } from "@chakra-ui/react";

export const DashboardContainer = forwardRef((props, ref) => {
  return <Flex position="absolute" top="0" left="0" bottom="0" right="0" ref={ref} {...props} />;
});
